import { Link, useLocation } from "react-router";

import { cn } from "@/lib/utils";
import { PROTECTED_ROUTES } from "@/navigation/routes";

type LocalRoute = {
  label: string;
  url: string;
  includeDescendants?: boolean;
};

// The archive is the Sections List's own Status choice (A25), never a second place to go.
const COURSE_ROUTES: readonly LocalRoute[] = [
  { label: "Sections", url: PROTECTED_ROUTES.admin.courses },
  { label: "Academic Structure", url: PROTECTED_ROUTES.admin.academicStructure },
];

const HISTORY_ROUTES: readonly LocalRoute[] = [
  { label: "Course History", url: PROTECTED_ROUTES.admin.courseHistory },
  {
    label: "Historical Imports",
    url: PROTECTED_ROUTES.admin.historicalImports,
    includeDescendants: true,
  },
];

function isActive(pathname: string, route: LocalRoute): boolean {
  return pathname === route.url
    || (route.includeDescendants === true && pathname.startsWith(`${route.url}/`));
}

export function RegistrarLocalNavigation({ area }: { area: "courses" | "history" }) {
  const { pathname } = useLocation();
  const routes = area === "courses" ? COURSE_ROUTES : HISTORY_ROUTES;

  return (
    <nav
      aria-label={area === "courses" ? "Courses" : "History"}
      className="flex min-w-0 flex-wrap items-center gap-1 border-b border-rule py-2"
    >
      {routes.map((route) => {
        const active = isActive(pathname, route);
        return (
          <Link
            key={route.url}
            to={route.url}
            aria-current={active ? "page" : undefined}
            className={cn(
              "inline-flex min-h-[var(--control-height-compact)] shrink-0 items-center rounded-control px-3 text-meta font-semibold transition-colors duration-[var(--motion-fast)] ease-[var(--ease-standard)] outline-none focus-visible:ring-2 focus-visible:ring-ring",
              active
                ? "bg-primary-wash text-primary"
                : "text-muted-foreground hover:bg-well hover:text-foreground",
            )}
          >
            {route.label}
          </Link>
        );
      })}
    </nav>
  );
}
